<div class="route-item" *ngIf="value" (click)="clickRoute.emit(value)" [style.background-color]="backgroundColor">
    <div class="route-title">{{ value.routeKey }}</div>
    <div class="time marginTime" *ngIf="value.marginTime">
        <i class="fa fa-step-forward" aria-hidden="true"></i>
        {{ value.marginTime | time }}
    </div>
    <div class="time waitingTime" *ngIf="value.waitingTime">
        <i class="fa fa-pause-circle" aria-hidden="true"></i>
        {{ value.waitingTime | time }}
    </div>

    <shared-slot-viewer-component class="route-bottom-strip relative element showDock" [slotInfo]="value.slotInfo">
    </shared-slot-viewer-component>

    <!--
    <shared-slot-viewer-component *ngIf="slotInfoPhase" class="relative element showDock" [slotInfo]="slotInfoPhase"
        [phaseId]="loadConsoleSlotPhase ? loadConsoleSlotPhase.phaseId : phaseslot.phaseId"
        [lostSlotId]="loadConsoleSlotPhase && loadConsoleSlotPhase.showLostSlotWhenReachedLate ? loadConsoleSlotPhase.lostSlotId : null"
        (callBack)="onCallBack($event)" [slotsMode]="slotsMode">
    </shared-slot-viewer-component>
-->
</div>